<template>
	<!-- Schedule Details -->
	<v-dialog v-if="localShowDialog && selectedSchedule !== null" v-model="localShowDialog" width="fit-content">
		<v-card style="height: 100%" class="mx-auto" :style="{ width: $vuetify.breakpoint.mdAndUp ? '60vw' : '90vw' }">
			<v-card-title class="text-h6 font-semibold card-header fixed-card-title2">
				<div class="truncate-text" style="max-width: calc(100% - 24px)">
					{{ $t('schedule') }} {{ $t('details') }} - {{ selectedSchedule.scheduleRuleName }}
				</div>
				<v-spacer />
				<v-icon @click="localShowDialog = false" class="white-icon">mdi-close</v-icon>
			</v-card-title>
			<v-card-text class="overflow-y-auto pt-6">
				<v-row dense>
					<v-col cols="12" class="text-left">
						<div class="text-subtitle-1 font-weight-bold">{{ $t('description') }}:</div>
						<!-- prettier-ignore -->
						<div class="text-body-1" style="white-space: pre-wrap">{{ selectedSchedule.scheduleRuleDescription || '-' }}</div>
					</v-col>
					<v-col cols="6" class="text-left">
						<div class="text-subtitle-1 font-weight-bold">{{ $t('coordinator') }}:</div>
						<div class="text-body-1">{{ selectedSchedule.scheduleOwnerName }}</div>
					</v-col>
					<v-col cols="12" class="text-left">
						<div class="text-subtitle-1 font-weight-bold">{{ $t('locations') }}:</div>
						<v-chip
							v-for="(location, index) in selectedSchedule.scheduleLocations
								.filter((loc) => loc.taskLocationName)
								.slice(0, showAllLocations ? selectedSchedule.scheduleLocations.length : 10)"
							:key="index"
							class="ma-1"
							small
							outlined>
							<v-icon color="primary">mdi-map-marker</v-icon>
							{{ location.taskLocationName }}
						</v-chip>
						<v-chip
							small
							color="primary"
							v-if="selectedSchedule.scheduleLocations.filter((loc) => loc.taskLocationName)?.length > 10"
							@click="showAllLocations = !showAllLocations">
							<span v-if="!showAllLocations">
								+{{ selectedSchedule.scheduleLocations.filter((loc) => loc.taskLocationName)?.length - 10 }}
								{{ $t('more') }}
							</span>
							<span v-else>{{ $t('view-less') }}</span>
						</v-chip>
					</v-col>
					<v-col cols="12" class="text-left">
						<div class="text-subtitle-1 font-weight-bold">{{ $t('Staff') }}:</div>
						<v-chip
							v-for="(executor, index) in selectedSchedule.scheduleExecutors.slice(
								0,
								showAllExecutors ? selectedSchedule.scheduleExecutors.length : 10,
							)"
							:key="index"
							class="ma-1"
							small
							outlined>
							{{ executor.taskExecutorUserName }}
						</v-chip>
						<v-chip
							small
							color="primary"
							v-if="selectedSchedule.scheduleExecutors.length > 10"
							@click="showAllExecutors = !showAllExecutors">
							<span v-if="!showAllExecutors">
								+{{ selectedSchedule.scheduleExecutors.length - 10 }} {{ $t('more') }}
							</span>
							<span v-else>{{ $t('view-less') }}</span>
						</v-chip>
					</v-col>
					<v-col cols="12" class="text-left">
						<div class="text-subtitle-1 font-weight-bold">{{ $t('task-lists') }}:</div>
						<div class="text-body-1 overflow-y-auto" style="max-height: 200px">
							<v-chip
								v-for="(taskList, index) in selectedSchedule.scheduleOccurrences"
								:key="index"
								class="ma-1"
								:color="taskList.color"
								:style="{ color: taskList.textColor }">
								{{ taskList.occurrenceName }}
							</v-chip>
						</div>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { formatTimestamp } from '../../utils/utilities';

export default {
	props: {
		showDialog: {
			type: Boolean,
			default: false,
		},
		selectedSchedule: {
			type: Object,
			default: null,
		},
	},
	data () {
		return {
			localShowDialog: false,
			showAllLocations: false,
			showAllExecutors: false,
		};
	},
	methods: {
		formatTimestamp,
	},
	watch: {
		showDialog: {
			immediate: true,
			handler (value) {
				this.localShowDialog = value;
			},
		},
		localShowDialog (value) {
			if (!value) {
				this.$emit('update:showDialog', false);
			}
		},
	},
};
</script>
